export const development = {
  SITE_KEY: '6LddCScoAAAAAP2H9RDf7AF1Q8xzQxmxbJAXHmCO'
}
export const staging = {
  SITE_KEY: '6LddCScoAAAAAP2H9RDf7AF1Q8xzQxmxbJAXHmCO'
}
export const production = {
  SITE_KEY: '6LddCScoAAAAAP2H9RDf7AF1Q8xzQxmxbJAXHmCO'
}
